import { useWorkflowPermission } from './useWorkflowPermission';

interface UseWorkflowExecutePermissionResult {
	hasExecutePermission: boolean;
	isCheckingPermissions: boolean;
}

/**
 * Hook that checks whether the current user has execute permission for a workflow.
 *
 * @param workflowId - The workflow ID to check permissions for
 * @param userName   - The authenticated user's login name
 */
export function useWorkflowExecutePermission(
	workflowId: string | undefined,
	userName: string | undefined
): UseWorkflowExecutePermissionResult {
	const { hasPermission, isCheckingPermission } = useWorkflowPermission(workflowId, userName, 'execute');

	return {
		hasExecutePermission: hasPermission,
		isCheckingPermissions: isCheckingPermission,
	};
}
